var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPfdb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-PFDB"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PFDB",
    clipPath: "url(#clip-PFDB)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    transform: "translate(16 171)",
    fill: "#070000",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 481,
    height: 258,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 480,
    height: 257,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    transform: "translate(23 181)",
    fill: "#070000",
    stroke: "#707070",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 481,
    height: 252,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 478,
    height: 249,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(6 14)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TRAIN_NO.",
    "data-name": "TRAIN NO.",
    transform: "translate(23 172)",
    fill: "#f2f4f6",
    fontSize: 14,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "TRAIN NO.")), /*#__PURE__*/React.createElement("text", {
    id: "TRAIN_NAME",
    "data-name": "TRAIN NAME",
    transform: "translate(175 172)",
    fill: "#f2f4f6",
    fontSize: 14,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "TRAIN NAME")), /*#__PURE__*/React.createElement("text", {
    id: "EXPT._TIME_A_D_PF_NO.",
    "data-name": "EXPT. TIME A/D PF NO.",
    transform: "translate(341 172)",
    fill: "#f2f4f6",
    fontSize: 14,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "EXPT. TIME A/D PF NO."))), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    transform: "translate(29 225)",
    fill: "#b2a7a7",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 468,
    height: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 467,
    height: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_12345_RAJDHANI_EXPRESS_10:10_A_10",
    "data-name": "12345          RAJDHANI EXPRESS              10:10          A        10",
    transform: "translate(36.5 230)",
    fill: "#f2f4f6",
    fontSize: 16,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17,
    xmlSpace: "preserve"
  }, "12345          RAJDHANI EXPRESS              10:10          A        10"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(0 41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_42-2",
    "data-name": "Rectangle 42",
    transform: "translate(29 225)",
    fill: "#b2a7a7",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 468,
    height: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 467,
    height: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_22345_GOMTI_EXPRESS_11:05_D_2",
    "data-name": "22345          GOMTI EXPRESS                     11:05          D         2",
    transform: "translate(36.5 230)",
    fill: "#f2f4f6",
    fontSize: 16,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17,
    xmlSpace: "preserve"
  }, "22345          GOMTI EXPRESS                     11:05          D         2"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(0 82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_42-3",
    "data-name": "Rectangle 42",
    transform: "translate(29 225)",
    fill: "#b2a7a7",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 468,
    height: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 467,
    height: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_12365_BHOPAL_SHATABDI_11:15_D_3",
    "data-name": "12365          BHOPAL SHATABDI                11:15          D         3",
    transform: "translate(36.5 230)",
    fill: "#f2f4f6",
    fontSize: 16,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17,
    xmlSpace: "preserve"
  }, "12365          BHOPAL SHATABDI                11:15          D         3"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(0 123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_42-4",
    "data-name": "Rectangle 42",
    transform: "translate(29 225)",
    fill: "#b2a7a7",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 468,
    height: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 467,
    height: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_31235_ITARSHI_LOCAL_CANCELLED",
    "data-name": "31235          ITARSHI LOCAL                             CANCELLED",
    transform: "translate(36.5 230)",
    fill: "#f2f4f6",
    fontSize: 16,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17,
    xmlSpace: "preserve"
  }, "31235          ITARSHI LOCAL                             CANCELLED"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(0 164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_42-5",
    "data-name": "Rectangle 42",
    transform: "translate(29 225)",
    fill: "#b2a7a7",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 468,
    height: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 467,
    height: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_12347_GAYA_EXPRESS_12:30_A_4",
    "data-name": "12347          GAYA EXPRESS                        12:30          A         4",
    transform: "translate(36.5 230)",
    fill: "#f2f4f6",
    fontSize: 16,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17,
    xmlSpace: "preserve"
  }, "12347          GAYA EXPRESS                        12:30          A         4")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfdb);
export default __webpack_public_path__ + "static/media/PFDB.857b8b84b4eeb23d97dd21e170c4a163.svg";
export { ForwardRef as ReactComponent };